import styled from "@emotion/styled"
import { PButtonPure, PText } from "@porsche-design-system/components-react"
import { colorContrastLow, spacingStaticLg, spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import type { CustomerFeedbackItem as FeedbackItem } from "@slfinrtl/ui-bff-routes"
import { useState } from "react"
import { FormattedMessage, FormattedRelativeTime } from "react-intl"
import type { MessageDescriptor } from "react-intl"
import { customerFeedbackMessages } from "./customerFeedback.messages"

const scoreTextMap: Record<number, MessageDescriptor> = {
	1: customerFeedbackMessages.veryDissatisfied,
	2: customerFeedbackMessages.somewhatDissatisfied,
	3: customerFeedbackMessages.neitherSatisfiedNorDissatisfied,
	4: customerFeedbackMessages.somewhatSatisfied,
	5: customerFeedbackMessages.verySatisfied,
}

export const CustomerFeedbackItem = ({ message, originalLanguageMessage, score, timeElapsed }: FeedbackItem) => {
	const [isEnglishFeedback, setIsEnglishFeedback] = useState(false)
	const nativeLanguageFeedback = originalLanguageMessage ?? message
	const isTranslatedFeedback = !!originalLanguageMessage
	const toggleFeedback = () => setIsEnglishFeedback((prev) => !prev)

	return (
		<FeedbackItemWrapper>
			<RatingContainer>
				{score && (
					<PText weight="semibold">
						<FormattedMessage {...scoreTextMap[score]} />
					</PText>
				)}
				<PText size="xs">
					(
					<FormattedRelativeTime value={timeElapsed.value} unit={timeElapsed.unit} />)
				</PText>
			</RatingContainer>
			<div>{isEnglishFeedback ? message : nativeLanguageFeedback}</div>
			{isTranslatedFeedback && (
				<PButtonPure type="button" onClick={toggleFeedback} icon="none" underline>
					<FormattedMessage
						{...(isEnglishFeedback
							? customerFeedbackMessages.showOriginalLanguageTextButton
							: customerFeedbackMessages.showEnglishTextButton)}
					/>
				</PButtonPure>
			)}
		</FeedbackItemWrapper>
	)
}

const FeedbackItemWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	gap: ${spacingStaticSm};
	padding: ${spacingStaticLg} 0;
	border-top: 1px solid ${colorContrastLow};
`

const RatingContainer = styled.div`
	display: flex;
	gap: ${spacingStaticSm};
	align-items: baseline;
`
